// Pazaryeri Ürünleri penceresi (platformdaki ürünleri getirme, seçme, stoka aktarma) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.marketplaceProducts';

export const marketplaceProductsModalGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Pazaryeri ürünleri nasıl getirilir ve aktarılır?'),
  intro: t(`${G}.intro`, 'Bu pencere bağlı pazaryerindeki ürünlerinizi listeler; seçtiklerinizi stok kartlarınızla eşleştirip içe aktarırsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Platform Ürünleri'),
    stats: t(`${G}.regions.stats`, 'Trendyol hızlı kontroller'),
    filters: t(`${G}.regions.filters`, 'Ürün Filtreleri'),
    toolbar: t(`${G}.regions.toolbar`, 'Arama, seçim ve aktarma düğmeleri'),
    table: t(`${G}.regions.table`, 'Ürün listesi'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'filters',
      title: t(`${G}.s1.title`, '1. Filtreleyin ve ürünleri getirin'),
      text: t(`${G}.s1.text`, 'Liste kendiliğinden dolmaz. Ürün ID, Ana Ürün ID, Stok Kodu, Marka Adı, Barkod ve Sayfa Boyutu ile süzüp "Ürünleri Getir"e basın; "Temizle" filtreleri sıfırlar, yenile simgesi aynı sorguyu tekrarlar. N11\'de Satış Durumu, Ürün Durumu ve Kategori ID\'leri; Trendyol\'da Ürün Kodu, Kategori ID, Onaylanmış, Arşivlenmiş, Satışta, Kampanyalı, Reddedilmiş, Kara Liste, Başlangıç / Bitiş Tarihi ve Sıralama filtreleri de vardır.'),
      tips: [
        t(`${G}.s1.tip1`, 'İki istek arasında en az 5 saniye bekleyin; daha sık basarsanız uyarı çıkar ve istek gönderilmez.'),
        t(`${G}.s1.tip2`, 'Trendyol dakikada en fazla 3 isteğe izin verir; çok fazla istek gönderilirse IP adresiniz geçici olarak engellenebilir.'),
      ],
    },
    {
      region: 'stats',
      title: t(`${G}.s2.title`, '2. Trendyol: sayfa ve toplu işlem takibi'),
      text: t(`${G}.s2.text`, 'Trendyol\'da liste üstündeki satır toplam kayıt sayısını ve sonraki sayfanın token\'ını gösterir; sonraki sayfayı almak için bu değeri "Next Page Token" alanına yazıp yeniden getirin. "Catalog Kontrolu" Trendyol marka ve kategori listesine erişimi dener. Ürün gönderiminden aldığınız numarayı "Batch Request ID" alanına yazıp "Batch Sonucu Sorgula"ya basınca toplu işlemin durumu ve hatalı kalem sayısı görünür.'),
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Listeyi inceleyin ve ürün seçin'),
      text: t(`${G}.s3.text`, 'Tabloda Ürün Adı, Fiyat, Stok, Kategori, Marka, Barkod/SKU ve Durum (Aktif / Pasif / Stokta Yok) görünür; stoğu 0 olan miktar kırmızıdır. Aktaracağınız satırların kutusunu işaretleyin.'),
      tips: [
        t(`${G}.s3.tip1`, '"Ürün ara..." kutusu yalnız getirilmiş ürünler içinde ada, markaya, kategoriye, barkoda ve SKU\'ya göre arar.'),
        t(`${G}.s3.tip2`, 'Başlıktaki kutu yalnız açık sayfadaki ürünleri seçer veya seçimi kaldırır. Seçili ürün sayısı sağ üstte yazar.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s4.title`, '4. Stokla eşleştirin'),
      text: t(`${G}.s4.text`, 'Ürün seçince alt köşede "N Ürünü Eşleştir" düğmesi çıkar. Basınca aktif stok kartlarınız yüklenir ve Ürün Eşleştirme penceresi açılır; orada her ürünün yeni stok kartı mı olacağını yoksa mevcut bir ürüne mi bağlanacağını belirleyip aktarırsınız.'),
      tips: [
        t(`${G}.s4.tip1`, 'Eşleştirme ile aktarılan yeni kartlarda miktar ve satış fiyatı pazaryerinden alınır; alış fiyatı satış fiyatının %80\'i, KDV %20 (dahil) olarak yazılır. Aktarımdan sonra bu değerleri stok kartında kontrol edin.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s5.title`, '5. Doğrudan içe aktarma'),
      text: t(`${G}.s5.text`, '"Doğrudan İçe Aktar" seçili ürünleri eşleştirme penceresi açmadan, pazaryeri servisi üzerinden içe aktarır. İşlem bitince aktarılan ürün sayısı mesajla bildirilir ve pencere kapanır.'),
    },
  ],
});
